import React from 'react';
import { SVGComponentProps } from 'modules/core/components/layout/svg/index';

export const UserSVG: React.FC<SVGComponentProps> = ({ className }: SVGComponentProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="17.5" height="19.5" viewBox="0 0 17.5 19.5" className={className}>
    <g transform="translate(0.75 0.75)">
    <path d="M20,21V19a4,4,0,0,0-4-4H8a4,4,0,0,0-4,4v2M16,7a4,4,0,1,1-4-4A4,4,0,0,1,16,7Z" transform="translate(-4 -3)"/>
    </g>
  </svg>
);